// 模块类型
export const MODULE_TYPE = {
  /** 未知 */
  UNKNOWN: 0,
  /** 金刚区 */
  KINGKONG: 1,
  /** 人脉名录 */
  CONTACT: 2,
  /** 直播/活动 */
  ACTIVITY: 3,
  /** 优质供需 */
  DEMAND: 4,
  /** 赢商学院 */
  COURSE: 5,
  /** 云会甄选 */
  YYDS: 6,
  /** 二级TAB */
  TAB: 7,
  /** 两个卡片 */
  TWO_CARD: 8,
  /** banenr */
  BANNER: 9,
  /** 社会组织 */
  CHAMBER: 10,
}

// 金刚区链接类型
export const KINGKONG_LINK_TYPE = {
  /** 页面 */
  PAGE: 1,
  /** 外部链接 */
  EXTERNAL_LINK: 2,
  /** 小程序 */
  MINIPROGRAM: 3,
  /** 自定义 */
  CUSTOM: 4,
}

// 金刚区链接页面类型
export const KINGKONG_PAGE_CONFIG = {
  /** 找组织 */
  ORGANIZATION: 1,
  /** 找人脉 */
  CONTACTS: 2,
  /** 找项目 */
  PROJECT: 3,
  /** AI助手 */
  AI: 4,
  /** 图片直播 */
  IMAGE: 5,
  /** 赢商学院 */
  COURSE: 6,
  /** 云会甄选 */
  YYDS: 7,
  /** 政策补贴 */
  POLICY: 8,
  /** 赋能计划 */
  PLAN: 9,
  /** 直播/活动 */
  ACTIVITY: 10,
}

// 模块列表状态
export const MODULE_STATUS = {
  /** 删除 */
  DELETE: 0,
  /** 正常 */
  NORMAL: 1,
  /** 隐藏 */
  HIDE: 2,
}
export const KINGKONG_PAGE_CONFIG_IMG_MAP = new Map([
  [KINGKONG_PAGE_CONFIG.ORGANIZATION, 'https://ysh-cdn.kaidicloud.com/prod/preview/chamber.jpg'],
  [KINGKONG_PAGE_CONFIG.CONTACTS, 'https://ysh-cdn.kaidicloud.com/prod/preview/connection.png'],
  [KINGKONG_PAGE_CONFIG.PROJECT, 'https://ysh-cdn.kaidicloud.com/prod/preview/demand.jpg'],
  [KINGKONG_PAGE_CONFIG.AI, 'https://ysh-cdn.kaidicloud.com/prod/preview/ai.jpg'],
  [KINGKONG_PAGE_CONFIG.IMAGE, 'https://ysh-cdn.kaidicloud.com/prod/preview/img-live.png'],
  [KINGKONG_PAGE_CONFIG.COURSE, 'https://ysh-cdn.kaidicloud.com/prod/preview/college.png'],
  // [KINGKONG_PAGE_CONFIG.YYDS, '云会甄选'],
  [KINGKONG_PAGE_CONFIG.POLICY, 'https://ysh-cdn.kaidicloud.com/prod/preview/policy.jpg'],
  [KINGKONG_PAGE_CONFIG.PLAN, 'https://ysh-cdn.kaidicloud.com/prod/preview/ecology.png'],
  [KINGKONG_PAGE_CONFIG.ACTIVITY, 'https://ysh-cdn.kaidicloud.com/prod/preview/activity-live.jpeg'],
])

/**
 * 0无 1凯迪文章 2会员动态 3热门活动 4热门供需 5赢商学院 6老板说 7图文动态 8视频动态 9话题 10平台资讯 11学习强企 12推荐
 */
export const TAB_TYPE = {
  /** 无 */
  NONE: 0,
  /** 凯迪文章 */
  ARTICLE: 1,
  /** 会员动态 */
  DYNAMIC: 2,
  /** 热门活动 */
  ACTIVITY: 3,
  /** 热门供需 */
  DEMAND: 4,
  /** 赢商学院 */
  COURSE: 5,
  /** 老板说 */
  BOSS: 6,
  /** 图文动态 */
  IMAGE: 7,
  /** 视频动态 */
  VIDEO: 8,
  /** 话题 */
  TOPIC: 9,
  /** 平台资讯 */
  NEWS: 10,
  /** 学习强企 */
  STRONG: 11,
  /** 推荐 */
  RECOMMEND: 12,
}

// 合作金额,0: 10万以下、1:10-50万、2:50-100万、3:100-500万、4:500万以上
export const COOPERATION_AMOUNT = {
  BELOW_10W: 0,
  '10_50W': 1,
  '50_100W': 2,
  '100_500W': 3,
  ABOVE_500W: 4,
}

export const COOPERATION_AMOUNT_MAP = new Map([
  [COOPERATION_AMOUNT.BELOW_10W, '10万以下'],
  [COOPERATION_AMOUNT['10_50W'], '10-50万'],
  [COOPERATION_AMOUNT['50_100W'], '50-100万'],
  [COOPERATION_AMOUNT['100_500W'], '100-500万'],
  [COOPERATION_AMOUNT.ABOVE_500W, '500万以上'],
])

// 供需类型
export const DEMAND_TYPE = {
  SUPPLY: 1,
  DEMAND: 2,
}

export const DEMAND_TYPE_MAP = new Map([
  [DEMAND_TYPE.SUPPLY, '供应'],
  [DEMAND_TYPE.DEMAND, '需求'],
])
